const GEN_AI_ONBOARDING_KEY = 'genAIOnboarding'
const GEN_AI_TEMPLATE = 'genAIOnboardingTemplate'

export const setSessionGenAiOnboarding = (key, value) => {
  let newGenAIOnboarding = {}
  let genAIOnboarding = sessionStorage.getItem(GEN_AI_ONBOARDING_KEY)
  genAIOnboarding = genAIOnboarding ? JSON.parse(genAIOnboarding) : null

  if (genAIOnboarding) {
    newGenAIOnboarding = {
      ...genAIOnboarding,
      [key]: value,
    }
  } else {
    newGenAIOnboarding = {
      [key]: value,
    }
  }
  sessionStorage.setItem(
    GEN_AI_ONBOARDING_KEY,
    JSON.stringify(newGenAIOnboarding),
  )
}


export const getSessionGenAIOnboarding = () => {
  let genAIOnboarding = sessionStorage.getItem(GEN_AI_ONBOARDING_KEY)
  genAIOnboarding = genAIOnboarding ? JSON.parse(genAIOnboarding) : null

  return genAIOnboarding
}

export const getSessionItemGenAIOnboarding = (key) => {
  let genAIOnboarding = sessionStorage.getItem(GEN_AI_ONBOARDING_KEY)
  genAIOnboarding = genAIOnboarding ? JSON.parse(genAIOnboarding) : {}

  return genAIOnboarding[key]
}


export const setGenAITemplate = (value) => {
  sessionStorage.setItem(GEN_AI_TEMPLATE, value)
}

export const getGenAITemplate = () => {
  return sessionStorage.getItem(GEN_AI_TEMPLATE)
}


export const GenAIIntent = [
  {
    label: 'Pre-sale',
    value: 'pre-sale',
    goals: [
      { label: 'Get More Subscription Purchases', value: 'get-more-subscription-purchases' },
      { label: 'Get More Quote Starts', value: 'get-more-quote-starts' },
      { label: 'Get More Trial Signups', value: 'get-more-trial-signups' },
      { label: 'Launch My Business', value: 'launch-my-business' },
      { label: 'Run Events or Webinars', value: 'run-events-or-webinars' },
    ]
  },
  {
    label: 'During-sale',
    value: 'during-sale',
    goals: [
      { label: 'Sell Your E-book', value: 'sell-your-ebook' },
      { label: 'Promote a New Product', value: 'promote-a-new-product' },
      { label: 'Offer Upsell', value: 'offer-upsell' },
      { label: 'Drive App. Downloads', value: 'drive-app-downloads' },
    ]
  },
  {
    label: 'Post-sale',
    value: 'post-sale',
    goals: [
      { label: 'Engage Existing Customers', value: 'engage-existing-customers' },
      { label: 'Gather Feedback', value: 'gather-feedback' },
      { label: 'Encourage Referrals', value: 'encourage-referrals' },
      { label: 'Offer Support', value: 'offer-support' },
    ]
  },
]

export const GenAICategories = [
  {
    label: 'Unknown',
    value: 'anonymous',
  },
  {
    label: 'Agriculture & Farming',
    value: 'agriculture-and-farming',
  },
  {
    label: 'Agriculture & Farming',
    value: 'agriculture-and-farming',
  },
  {
    label: 'Automotive & Mobility',
    value: 'automotive-and-mobility',
  },
  {
    label: 'Beauty & Personal Care',
    value: 'beauty-and-personal-care',
  },
  {
    label: 'Construction & Real Estate',
    value: 'construction-and-real-estate',
  },
  {
    label: 'Consumer Goods',
    value: 'consumer-goods',
  },
  {
    label: 'Design, Creative & Branding',
    value: 'design-creative-and-branding',
  },
  {
    label: 'E-commerce',
    value: 'e-commerce',
  },
  {
    label: 'Education & EdTech',
    value: 'education-and-edtech',
  },
  {
    label: 'Energy & Utilities',
    value: 'energy-and-utilities',
  },
  {
    label: 'Entertainment & Media',
    value: 'entertainment-and-media',
  },
  {
    label: 'Environmental Services & Sustainability',
    value: 'environmental-services-and-sustainability',
  },
  {
    label: 'Events & Experiences',
    value: 'events-and-experiences',
  },
  {
    label: 'Fashion & Apparel',
    value: 'fashion-and-apparel',
  },
  {
    label: 'Financial Services',
    value: 'financial-services',
  },
  {
    label: 'Fintech & Payments',
    value: 'fintech-and-payments',
  },
  {
    label: 'Fintech & Payments',
    value: 'fintech-and-payments',
  },
  {
    label: 'Food & Beverage',
    value: 'food-and-beverage',
  },
  {
    label: 'Gaming & Esports',
    value: 'gaming-and-esports',
  },
  {
    label: 'Government & Public Services',
    value: 'government-and-public-services',
  },
  {
    label: 'Healthcare & Medical',
    value: 'healthcare-and-medical',
  },
  {
    label: 'Hospitality & Travel',
    value: 'hospitality-and-travel',
  },
  {
    label: 'HR, Staffing & Recruitment',
    value: 'hr-and-staffing-and-recruitment',
  },
  {
    label: 'Industrial Manufacturing',
    value: 'industrial-manufacturing',
  },
  {
    label: 'Information Technology & Services',
    value: 'information-technology-and-services',
  },
  {
    label: 'Insurance',
    value: 'insurance',
  },
  {
    label: 'Legal & Compliance',
    value: 'legal-and-compliance',
  },
  {
    label: 'Logistics & Supply Chain',
    value: 'logistics-and-supply-chain',
  },
  {
    label: 'Marketing & Advertising',
    value: 'marketing-and-advertising',
  },
  {
    label: 'Mining & Natural Resources',
    value: 'mining-and-natural-resources',
  },
  {
    label: 'Nonprofit & NGOs',
    value: 'nonprofit-and-ngos',
  },
  {
    label: 'Pharmaceuticals & Biotech',
    value: 'pharmaceuticals-and-biotech',
  },
  {
    label: 'Printing & Packaging',
    value: 'printing-and-packaging',
  },
  {
    label: 'Professional & Consulting Services',
    value: 'professional-and-consulting-services',
  },
  {
    label: 'Real Estate (Sales, Leasing, Management)',
    value: 'real-estate-sales-leasing-management',
  },
  {
    label: 'Renewable Energy & CleanTech',
    value: 'renewable-energy-and-cleantech',
  },
  {
    label: 'Restaurants, Cafes & QSR',
    value: 'restaurants-cafes-qsr',
  },
  {
    label: 'Retail (Physical Stores)',
    value: 'retail-physical-stores',
  },
  {
    label: 'Restaurants, Cafes & QSR',
    value: 'restaurants-cafes-qsr',
  },
  {
    label: 'SaaS / Software Products',
    value: 'saas-software-products',
  },
  {
    label: 'Security (Cyber & Physical)',
    value: 'security-cyber-and-physical',
  },
  {
    label: 'SaaS / Software Products',
    value: 'saas-software-products',
  },
  {
    label: 'Security (Cyber & Physical)',
    value: 'security-cyber-and-physical',
  },
  {
    label: 'Sports, Fitness & Wellness',
    value: 'sports-fitness-and-wellness',
  },
  {
    label: 'Telecommunications',
    value: 'telecommunications',
  },
  {
    label: 'Transportation (Air, Land, Sea)',
    value: 'transportation-air-land-sea',
  },
  {
    label: 'Web3 / Blockchain / Crypto',
    value: 'web3-blockchain-crypto',
  },
  {
    label: 'Wholesale & Distribution',
    value: 'wholesale-and-distribution',
  },
  {
    label: 'Other',
    value: 'other',
  },
]

export const genAIIntentList = GenAIIntent.map(intent => intent.value);

export const genAIIntentGoalList = GenAIIntent.reduce((goals, intent) => {
  intent.goals.forEach(goal => {
    goals.push(goal.value);
  });
  return goals;
}, []);